// Coalesce resume/timer events; never publish a result after unmount/account change.
export function watchSession({refresh,onReady,onError,forceRefresh=false,win=window,doc=document}){
 let active=true,pending=false;
 async function run(force=false){if(!active||pending)return;pending=true;try{await refresh({forceRefresh:force});if(active)onReady();}catch(error){if(active)onError(error);}finally{pending=false;}}
 const resume=()=>{if(doc.visibilityState!=='hidden')run();};
 run(forceRefresh);
 const timer=win.setInterval(resume,60000);
 win.addEventListener('focus',resume);win.addEventListener('online',resume);doc.addEventListener('visibilitychange',resume);
 return ()=>{active=false;win.clearInterval(timer);win.removeEventListener('focus',resume);win.removeEventListener('online',resume);doc.removeEventListener('visibilitychange',resume);};
}
